import { MEDIA_URL_REGEXP } from '../constants';

export function extractIdFromSrc(src = '') {
  const match = src.match(MEDIA_URL_REGEXP);
  return match ? match[1] : src;
}
